<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    icon: String,
    title: String,
    href: String,
  });

  const wrapperType = computed(() => (!!props.href ? 'a' : 'div'));
</script>

<template>
  <component
    :is="wrapperType"
    :href="href"
    target="_blank"
    class="module-wrapper"
  >
    <div class="icon">
      <slot name="icon" />
    </div>
    <strong>{{ title }}</strong>
    <slot />
  </component>
</template>

<style lang="scss">
  @import '~assets/styles/palette';

  .module-wrapper {
    display: grid;
    grid-template-rows: 45px 58px 1fr;
    flex-direction: column;
    gap: 1em;
    align-items: center;
    padding: 2.5em 2em;
    border: 2px solid $bb-purple-plus;
    border-radius: 0.5em;
    background: white;

    .icon {
      margin: auto;

      svg {
        height: 45px;
      }
    }

    strong {
      text-align: center;
      font-weight: 600;
      font-size: 1.5em;
      color: $bb-primary-300;
    }

    p {
      font-size: 20px;
      font-weight: 400;
      color: $bb-primary-300;
      text-align: center;
    }

    @media (max-width: 720px) {
      gap: 0.25em;
      grid-template-rows: 32px 45px 1fr;
      padding: 16px;

      strong {
        font-size: 16px;
      }

      p {
        font-size: 14px;
      }

      .icon > svg {
        height: 32px;
      }
    }
  }
</style>
